export const LIBRARY_PLUGIN_NAME = 'widen-library';
export const TYPE_DOCUMENT = 'documents';
export const TYPE_PDF_OFFICE_ARCHIVE = 'pdf or office or archive';
export const TITLE_LABEL = 'Title:';
export const ERROR_DISPLAY_NAME = "This asset has no 'Display Name' from Widen";
export const WINDEN_BUTTON_LABEL = 'Insert Widen Asset';